import React from "react";
import HeroImage from "../assets/heroImage1.png";
import { HiOutlineArrowRight } from "react-icons/hi";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div
      name="home"
      className="h-screen w-full bg-gradient-to-b from-black via-black
    to-gray-800 text-white"
    >
      <div
        className="max-w-screen-lg mx-auto flex flex-col
        items-center justify-center h-full px-4 md:flex-row"
      >
        <div className="flex flex-col justify-center h-full">
          <div
            className="flex flex-row max-w-full text-4xl sm:text-6xl font-bold
           text-white"
          >
            <p>
              I'm a Developer <span className="animate-waving-hand">👋</span>
            </p>
          </div>
          <p className="text-gray-300 py-4 max-w-lg">
            Hey, Welcome to my space. I have experience of building and
            designing web application. I love to work on web application using
            framework and languages like React, Tailwind, JavaScript, Node and
            much more.Learning never stop so i am still exploring other
            technologies also.
          </p>

          <div>
            <Link
              to="portfolio"
              smooth
              duration={500}
              className="group w-fit px-3 py-6 my-2 h-3 flex items-center bg-gradient-to-r
              from-gray-900 to-gray-500
            rounded-2xl cursor-pointer"
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300 pl-2">
                <HiOutlineArrowRight size={23} />
              </span>
            </Link>
          </div>
        </div>
        <div>
          <img
            src={HeroImage}
            alt="my profile"
            className="rounded-3xl object-contain 
                 mx-auto w-2/3 md:w-full scale-75 h-30"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
